export default {
    app: {
        name: 'ActivityWatch',
        researchEdition: 'Research Edition',
    },
    nav: {
        activity: 'Активность',
        loading: 'Загрузка…',
        noActivityReports: 'Отчётов об активности нет. Убедитесь, что запущены AFK- и window-watcher.',
        timeline: 'Хронология',
        stopwatch: 'Секундомер',
        tools: 'Инструменты',
        search: 'Поиск',
        workReport: 'Отчёт о работе',
        trends: 'Тренды',
        report: 'Отчёт',
        alerts: 'Уведомления',
        timespiral: 'Timespiral',
        query: 'Запросы',
        graph: 'Граф',
        rawData: 'Сырые данные',
        settings: 'Настройки',
    },
    footer: {
        madeWith: 'Сделано с',
        byDevs: 'разработчиками ActivityWatch',
        host: 'Хост:',
        version: 'Версия:',
        reportBug: 'Сообщить об ошибке',
        askHelp: 'Попросить помощь',
        voteFeatures: 'Голосовать за функции',
        twitter: 'Twitter',
        github: 'GitHub',
        reddit: 'Reddit',
        donate: 'Поддержать',
    },
    common: {
        loading: 'Загрузка…',
        save: 'Сохранить',
        cancel: 'Отмена',
        confirm: 'Подтвердить',
        import: 'Импорт',
        export: 'Экспорт',
        open: 'Открыть',
        more: 'Ещё',
        delete: 'Удалить',
        enabled: 'Включено',
        disabled: 'Выключено',
        home: 'Главная',
        language: 'Язык',
        languageUk: 'Українська',
        languageEn: 'English',
        languageDe: 'Deutsch',
        languageRu: 'Русский',
        languageSv: 'Svenska',
        languageZhCN: '简体中文',
        rangeTo: 'до',
    },
    notFound: {
        title: 'Ой, эта страница не найдена!',
        hint: 'Попробуйте вернуться туда, откуда пришли.',
    },
    settings: {
        title: 'Настройки',
        unsavedCategoriesLeave: 'В категориях есть несохранённые изменения. Действительно выйти?',
        daystart: {
            startOfDay: 'Начало дня',
            startOfDayHelp: 'Время, когда «начинается» новый день — люди не всегда ложатся спать до полуночи. По умолчанию 04:00.',
            startOfWeek: 'Начало недели',
            startOfWeekHelp: 'День недели, с которого начинается новая неделя.',
            saturday: 'Суббота',
            sunday: 'Воскресенье',
            monday: 'Понедельник',
        },
        timelineDuration: {
            title: 'Длительность по умолчанию',
            help: 'Длительность по умолчанию для «показать последние» в хронологии.',
        },
        landingPage: {
            title: 'Стартовая страница',
            home: 'Главная',
            activity: 'Активность ({hostname})',
            timeline: 'Хронология',
            help: 'Страница при открытии ActivityWatch или клике на логотип в меню.',
        },
        theme: {
            title: 'Тема',
            auto: 'Авто (системная)',
            light: 'Светлая',
            dark: 'Тёмная',
            help: 'Цветовая тема интерфейса (цвета категорий для тёмного режима настраиваются вручную).',
        },
        groups: {
            general: 'Общие',
            generalHelp: 'Параметры по умолчанию для периодов, хронологии и стартовой страницы.',
            appearance: 'Внешний вид',
            appearanceHelp: 'Тема и цвета визуализаций.',
            categorization: 'Категоризация',
            categorizationHelp: 'Правила классификации событий по категориям и переопределения AFK/активности.',
            privacy: 'Конфиденциальность',
            privacyHelp: 'Фильтры, отбрасывающие или скрывающие чувствительные данные событий перед сохранением.',
            developer: 'Разработчик',
        },
        language: {
            title: 'Язык',
            help: 'Язык интерфейса веб-приложения.',
        },
        releaseNotification: {
            title: 'Проверка новых версий',
            help: 'Если включено, веб-интерфейс раз в день проверяет наличие новой версии ActivityWatch и показывает подсказку.',
        },
        color: {
            title: 'Резервные цвета',
            help: 'Старый стиль цветов для некоторых визуализаций без категории или цвета категории.',
        },
        activePattern: {
            title: 'Всегда считать активным (regex)',
            help1: 'Приложения или заголовки по этому regex никогда не будут помечены как AFK.',
            help2: 'Полезно для встреч или игр с геймпадом без ввода с клавиатуры/мыши. Пустая строка отключает правило.',
            example: 'Пример выражения:',
            invalid: 'Некорректный шаблон',
            tooBroad: 'Слишком широкий шаблон',
        },
        categorization: {
            title: 'Категоризация',
            restoreDefaults: 'Сбросить к типовым',
            rulesHelp: 'Правила категоризации событий. У события только одна категория. Если подходит несколько — выбирается самая глубокая.',
            builderIntro: 'Можно использовать',
            categoryBuilder: 'Конструктор категорий',
            builderOutro: 'чтобы быстро создать категории из некатегоризованной активности.',
            forumIntro: 'Готовые наборы правил можно найти на',
            forum: 'форуме',
            docsIntro: 'Справка по написанию правил — в',
            documentation: 'документации',
            categorySet: 'Набор категорий:',
            newSet: 'Новый набор',
            deleteSet: 'Удалить набор',
            setsAvailable: 'Доступно наборов: {count} — переключайте профили правил.',
            unsavedChanges: 'Есть несохранённые изменения!',
            discard: 'Отбросить',
            addCategory: 'Добавить категорию',
            categories: 'Категории',
            priority: 'Приоритет',
            priorityDefault: 'По умолчанию',
            priorityInteger: 'Приоритет должен быть целым числом.',
            builderTitle: 'Конструктор категорий',
            builderSubtitle: 'Создание правил из некатегоризированной активности',
            openBuilder: 'Открыть конструктор',
            hideBuilder: 'Скрыть конструктор',
        },
        developer: {
            title: 'Настройки разработчика',
            note: 'Внимание:',
            noteBody: 'Эти параметры для разработчиков; необдуманное изменение может что-то сломать.',
            forceDevmode: 'Принудительный devmode',
            forceDevmodeHelp: 'Devmode включает функции, которые ещё в разработке.',
            requestTimeout: 'Таймаут запроса',
            requestTimeoutHelp: 'Максимальное время ожидания ответа сервера. Для больших запросов можно увеличить. Нужно перезагрузить веб-интерфейс.',
            commitHash: 'Хеш коммита веб-UI:',
        },
    },
    home: {
        note: 'Примечание:',
        androidNote: 'ActivityWatch на Android на очень ранней стадии. Будут ошибки, но мы работаем над паритетом с десктопной версией (её стоит попробовать!).',
        greeting: 'Добро пожаловать в ActivityWatch',
        intro1: 'Мы прошли долгий путь{android}, но нам по-прежнему нужны пользователи (как вы!), чтобы сделать ActivityWatch успешным проектом. Будем рады вашим идеям по улучшению.',
        introAndroid: ' (особенно на Android!)',
        intro3: 'Если вы разработчик, помогите watcher-ом, визуализацией или другим — и поделитесь на форуме!',
        thanks: 'Спасибо, что пользуетесь ActivityWatch!',
        surveyFill: 'Заполните наш опрос пользователей',
        surveySuffix: 'чтобы повлиять на то, что будет дальше.',
        surveyOr: 'или',
        voteForum: 'проголосуйте за функции на форуме',
        spreadTitle: 'Распространяйте проект',
        spread1: 'Лучшая мотивация — когда ActivityWatch попадает к новым людям. Делитесь — и мы сделаем его ещё лучше!',
        spreadReview: 'Оставьте отзыв на',
        spreadVote: 'Проголосуйте за нас на',
        spreadFollow: 'Следите и делитесь в',
        spreadStar: 'Поставьте звезду на',
        supportTitle: 'Поддержите нас!',
        subscribeIntro: 'The best way to keep ActivityWatch maintained is a subscription — from $5/month, every feature stays free, cancel anytime.',
        subscribeCta: 'Support ActivityWatch →',
        support1: 'Нравится ActivityWatch? Помогите нам помочь вам — пожертвование через:',
        support2: 'Подробнее — на',
        donationPage: 'странице пожертвований на сайте',
        otherDonationMethods: 'Другие способы (включая криптовалюту)',
        resourcesTitle: 'Ресурсы',
        website: 'Сайт',
        documentation: 'Документация',
        forum: 'Форум',
        discord: 'Discord',
        reddit: 'Reddit',
        apiBrowser: 'Просмотр API',
        workingOnTitle: 'Над чем мы работаем',
        workingOnPrefix: 'Следите за',
        devUpdates: 'новостями разработки',
        workingOnMiddle: 'и за проектом на',
        workingOnSuffix: 'чтобы читать заметки к релизам.',
        landingHint: 'Страницу при открытии ActivityWatch (вместо этой) можно изменить в',
        supporterNudge: {
            message: "You've been getting a lot out of ActivityWatch — would you consider supporting its development?",
            support: 'Support ActivityWatch →',
            notNow: 'Not now',
        },
    },
    buckets: {
        title: 'Bucket-и',
        moreWatchers: 'Хотите собирать больше данных? Смотрите',
        docsLink: 'документацию',
        thisDevice: 'это устройство',
        lastUpdatedInline: 'Последнее обновление',
        noEventsYet: 'Событий пока не записано',
        noEvents: 'нет событий',
        moreActionsFor: 'Дополнительные действия для {hostname}',
        deleteAllTitle: 'Удалить все {count} bucket-ов для {hostname}',
        deleteAllForHost: 'Удалить все bucket-и этого хоста',
        openBucket: 'Открыть bucket',
        deleteBucketTitle: 'Удалить bucket?',
        deleteHostTitle: 'Удалить bucket-и?',
        deleteHostTitleNamed: 'Удалить все bucket-и для {hostname}?',
        deleteHostConfirmPrefix: 'Вы уверены, что хотите удалить',
        deleteHostConfirmCount: 'все {count} bucket-ов',
        deleteHostConfirmSuffix: 'для хоста «{hostname}»?',
        bucketsToDelete: 'Bucket-и, которые будут удалены:',
        deleting: 'Удаление…',
        importing: 'Импорт…',
        importHelpNew: 'Нужен JSON, экспортированный из одного или нескольких bucket-ов. Импорт не удастся, если bucket с таким ID уже существует.',
        exportHelp: 'Скачать все bucket-и с этого сервера одним JSON-файлом. Для резервных копий.',
        currentDevice: '(текущее устройство)',
        lastUpdated: 'Обновлено:',
        firstSeen: 'Впервые замечено:',
        bucketId: 'ID bucket-а',
        updated: 'Обновлено',
        exportBucketJson: 'Экспорт bucket-а в JSON',
        exportEventsCsv: 'Экспорт событий в CSV',
        deleteBucket: 'Удалить bucket',
        deleteModalTitle: 'Опасно!',
        deleteConfirm: 'Удалить bucket «{id}»?',
        deletePermanent: 'Это навсегда и нельзя отменить!',
        importExportTitle: 'Импорт и экспорт bucket-ов',
        importBuckets: 'Импорт bucket-ов',
        importPlaceholder: 'Выберите или перетащите файл…',
        importDrop: 'Перетащите файл сюда…',
        importHelp: 'Нужен JSON: экспорт одного bucket-а или нескольких. Если имена совпадают — импорт не удастся.',
        exportBuckets: 'Экспорт bucket-ов',
        exportAllJson: 'Экспорт всех bucket-ов в JSON',
        tools: 'Инструменты',
    },
    activity: {
        title: 'Активность',
        browserAllowlistMiss: 'Для этого периода не найдено подходящее окно браузера. Если вы использовали форк Chromium/Firefox, имя его приложения может пока не распознаваться.',
        for: 'для',
        host: 'Хост:',
        devices: 'Устройства:',
        allDevices: 'Все устройства',
        allDevicesCount: 'Все устройства ({count})',
        onlyThisDevice: 'только',
        multideviceNote: 'Данные браузера и секундомера доступны только при просмотре одного устройства.',
        timeActive: 'Активное время:',
        queryRange: 'Диапазон запроса:',
        filters: 'Фильтры',
        filtersTitle: 'Фильтры',
        refresh: 'Обновить',
        excludeAfk: 'Исключить время AFK',
        audibleActive: 'Слышимую вкладку браузера считать активностью',
        includeStopwatch: 'Включить ручные события (секундомер)',
        newView: 'Новый просмотр',
        loadDemo: 'Загрузить демо-данные',
        periodDay: 'день',
        periodWeek: 'неделя',
        periodMonth: 'месяц',
        periodYear: 'год',
        periodLast7d: '7 дней',
        periodLast30d: '30 дней',
        periodLast7dTitle: 'последние 7 дней',
        periodLast30dTitle: 'последние 30 дней',
        periodCustomRange: 'свой диапазон',
        rangeStart: 'Дата начала',
        rangeEnd: 'Дата окончания',
        invalidRange: 'Неверный диапазон дат в URL, показан сегодняшний день.',
        periodAllTime: 'всё время',
        allTimeSlowHint: 'Загрузка за всё время может занять время на больших базах данных.',
        filterAfkTooltip: 'Скрыть время, когда AFK-watcher не фиксировал ввод с клавиатуры или мыши.',
        filterAudibleTooltip: 'Если активное окно — вкладка браузера со звуком, считать активностью. Нужен browser watcher.',
        showCategory: 'Показать категорию',
        newViewTitle: 'Новый просмотр',
        viewId: 'ID',
        viewName: 'Название',
        stopwatchWipNote: 'Внимание: WIP. События секундомера перекрывают другие при наложении. Только в devmode.',
        invalidForm: 'Некорректные данные формы: {errors}',
        errIdNotUnique: 'ID не уникален',
        errMissingId: 'Нет ID',
        errMissingName: 'Нет названия',
    },
    activityView: {
        addVisualization: 'Добавить визуализацию',
        cancel: 'Отмена',
        save: 'Сохранить',
        restoreDefaults: 'Сбросить к типовым',
        remove: 'Удалить',
        editView: 'Редактировать просмотр',
        restoreAlert: 'Все просмотры сброшены к типовым. Изменения не сохранятся, пока не нажмёте «Сохранить».',
        removeViewTitle: 'Удалить этот вид?',
        removeViewOk: 'Удалить вид',
        removeViewConfirm: 'Вы уверены, что хотите удалить',
        removeViewHint: 'Это удалит конфигурацию вида. Можно выполнить',
        removeViewRestoreHint: 'чтобы вернуть стандартные виды.',
        promptWatcher: 'Введите имя watcher',
        promptTitle: 'Введите название визуализации',
    },
    uncategorized: {
        title: 'Много некатегоризованного времени',
        body: 'Всего {duration} некатегоризованного времени — это {percent}% всего времени за {period}.',
        hint: 'Можно исправить через',
        categoryBuilder: 'Конструктор категорий',
        settingsCogTitle: 'Скрыть или настроить эту подсказку в параметрах',
        periodToday: 'сегодня',
        periodThisWeek: 'эту неделю',
        periodThisMonth: 'этот месяц',
        periodThisYear: 'этот год',
        periodLast7d: 'последние 7 дней',
        periodLast30d: 'последние 30 дней',
        periodCustomRange: 'за выбранный период',
        periodAllTime: 'за всё время',
    },
    visualizations: {
        noData: '(нет данных)',
        unsupportedPeriod: 'Эта функция не поддерживает выбранный период времени.',
        missingWatcher: 'Нет данных от нужного watcher.',
        docLink: 'документации',
        allCategories: 'Все',
        topApps: 'Топ приложений',
        topTitles: 'Топ заголовков окон',
        topDomains: 'Топ доменов браузера',
        topUrls: 'Топ URL браузера',
        topBrowserTitles: 'Топ заголовков браузера',
        topEditorFiles: 'Топ файлов редактора',
        topEditorLanguages: 'Топ языков редактора',
        topEditorProjects: 'Топ проектов редактора',
        topCategories: 'Топ категорий',
        categoryTree: 'Дерево категорий',
        categorySunburst: 'Sunburst категорий',
        timelineBarchart: 'Хронология (столбцы)',
        sunburstClock: 'Sunburst часы',
        dailyTimeline: 'Дневная хронология',
        customVis: 'Своя визуализация',
        score: 'Оценка',
        topStopwatches: 'Топ событий секундомера',
        topBucketData: 'Топ данных bucket',
    },
    timeline: {
        title: 'Хронология',
        eventsShown: 'Показано событий:',
        swimlanes: 'Дорожки:',
        filterAfk: 'Фильтр AFK',
        mergeByApp: 'Объединить по приложению',
        noEvents: 'Нет событий по выбранным критериям. Хронология не обновлена.',
        scrollHint: 'Колёсико — масштаб, свайп/горизонтальная прокрутка — панорама, стрелки — навигация',
        loading: 'Загрузка…',
    },
    stopwatch: {
        title: 'Секундомер',
        usingBucket: 'Bucket:',
        aboutTitle: 'О секундомере',
        aboutBody: 'Отслеживайте сессии, записанные вручную, вместе с автоматическим учётом. Чтобы видеть итоги секундомера на панели, откройте вид активности, нажмите «Редактировать вид», затем «Добавить визуализацию» и выберите «Топ событий секундомера».',
        placeholder: 'Над чем вы работаете?',
        noRunning: 'Секундомер не запущен. Запустите его выше, чтобы отслеживать сфокусированную работу.',
        start: 'Старт',
        running: 'Идёт',
        history: 'История',
    },
    search: {
        title: 'Поиск',
        earlyDev: 'Функция ещё на ранней стадии разработки.',
        searchBtn: 'Искать',
        options: 'Параметры',
        notFound: 'Не нашли нужное?',
        addWeek: 'Добавить неделю к поиску:',
        addWeekBtn: '+1 неделя',
    },
    query: {
        title: 'Обозреватель запросов',
        docsHelp: 'Справка по написанию запросов — в документации.',
        start: 'Начало',
        end: 'Конец',
    },
    workReport: {
        title: 'Отчёт о рабочем времени',
        loading: 'Загрузка…',
    },
    report: {
        title: 'Отчёт',
        description: 'Отчёт о времени в определённой категории активности устройства.',
        earlyDev: 'Функция ещё на ранней стадии разработки.',
        generate: 'Сгенерировать',
        options: 'Параметры',
        foundEvents: 'Найдено событий: {count} за {seconds} с',
        csv: 'CSV',
    },
    trends: {
        titlePrefix: 'Тренды за',
        earlyDev: 'Функция ещё на ранней стадии разработки.',
        loadDemo: 'Загрузить демо-данные',
    },
    timespiral: {
        title: 'Timespiral',
        wip: 'Экспериментальная функция в разработке.',
        noAfkBucket: 'На этом хосте не найден AFK bucket. Установите',
        noAfkBucketSuffix: 'чтобы использовать Timespiral.',
        bucketLabel: 'Bucket:',
        eventsLabel: 'Событий:',
    },
};
